"use strict";import{IconCartThick as c}from"../src/elements/IconCartThick.js";customElements.get("cu-icon-cart-thick")||customElements.define("cu-icon-cart-thick",c);
//# sourceMappingURL=cu-icon-cart-thick.js.map
